// frontend/js/translationHelper.js

const get = (obj, path) => path.split('.').reduce((o, k) => (o && o[k] != null ? o[k] : undefined), obj);
const fmt = (str, params) => !params ? str : str.replace(/\{(\w+)\}/g, (_, k) => (k in params ? params[k] : `{${k}}`));

export const t = (key, paramsOrFallback) => {
  const i18n = window.i18n;
  const hasParamsObj = paramsOrFallback && typeof paramsOrFallback === 'object' && !Array.isArray(paramsOrFallback);
  const params = hasParamsObj ? paramsOrFallback : undefined;
  const fallback = !hasParamsObj && typeof paramsOrFallback !== 'undefined' ? paramsOrFallback : undefined;

  // detect language once, consistently
  const lang =
    (i18n?.lang || localStorage.getItem('preferredLanguage') || 'en')
      .toString()
      .slice(0, 2);

  // markers like "[traduction manquante] ..." or "[translation missing] ..."
  const MISSING_RE = /^\s*\[(?:traduction manquante|translation missing)[^\]]*\]\s*$/i;

  // If user is English, always show the provided fallback (base text) when available
  if (lang === 'en' && typeof fallback !== 'undefined') {
    return typeof fallback === 'string' ? fmt(fallback, params) : fallback;
  }

  let val;

  if (i18n?.t) {
    val = i18n.t(key, params);
  } else {
    const dict = window.__STATIC_TRANSLATIONS__ || globalThis.ZTranslations || {};
    const root = dict[lang] || dict.en || {};
    const base = root.translation || root;
    const found = get(base, key);
    val = typeof found === 'string' ? fmt(found, params) : undefined;
  }

  // Standard fallbacks
  if (val == null || val === key || (typeof val === 'string' && MISSING_RE.test(val))) {
    if (typeof fallback !== 'undefined') {
      return typeof fallback === 'string' ? fmt(fallback, params) : fallback;
    }
  }
  return val ?? key;
};


export const confirmT = (key, fallbackOrParams) => confirm(t(key, fallbackOrParams));

export const updateElementText = (sel, key, fallbackOrParams) => {
  const el = typeof sel === 'string' ? document.querySelector(sel) : sel;
  if (el) el.textContent = t(key, fallbackOrParams);
};

// Optional helper for attributes (placeholders, titles, etc.)
export const updateElementAttr = (sel, attr, key, fallbackOrParams) => {
  const el = typeof sel === 'string' ? document.querySelector(sel) : sel;
  if (el) el.setAttribute(attr, t(key, fallbackOrParams));
};
